import { render, staticRenderFns } from "./AiAssessments.vue?vue&type=template&id=2e74b80b&scoped=true"
import script from "./AiAssessments.vue?vue&type=script&lang=ts"
export * from "./AiAssessments.vue?vue&type=script&lang=ts"
import style0 from "./AiAssessments.vue?vue&type=style&index=0&id=2e74b80b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e74b80b",
  null
  
)

export default component.exports